module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Row for Freedom: Crossing an Ocean In Search of Hope")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "pagexv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ttxv",
      "id": "iwxv"
    }
  }, [_vm._v("Author’s Note: Why Write This Book?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("M")]), _vm._v("y bookshelf is only half-full at home. I’m not a big reader. So why write a book? Good question. To answer it I need to tell you a bit about myself. I’ve always thought of myself as a natural-born optimist, a semipro dreamer of big dreams, but even as a child I knew that things often don’t turn out quite as well in real life as they do in your head. Even though somewhere within me I had a hunch that something great could happen, I learned to limit my choices, to water down the dreams. Great exam grades; a beautiful house; a perfectly happy, successful, and normal-looking family were beyond my reach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then I saw a movie and got stirred up. It was as if someone pulled back the curtain on the real world and showed me the ugly truth that bad things happen to innocent people. For the first time I realized how odd it was to complain about my life not going according to plan. I had my freedom, and I had hope. What was there to complain about?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The revelations didn’t stop there. I worked out that nobody’s qualified to change the world. No one is clever enough, kind "), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_vm._v(" enough, patient enough, or whatever enough to solve the world’s problems on his or her own. And those failings shouldn’t hold us back.")])]), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I changed. I went from self-medicating with relationships and handbags to breaking two world records for ocean rowing. There were plenty of reasons not to do it: I was in debt, I was worried about my family, and a year and a half earlier I’d never sat in a rowing boat. But those reasons weren’t big enough to put me off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Getting stirred up by a cause, rowing the ocean, starting a charity—these things were completely out of character for me. I’m an ordinary girl, but this extraordinary adventure taught me that all of us have the potential to become passionate about some of the things that need changing in this world and work to bring about change.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Along the way there are struggles and difficulties, dangers and setbacks. Yet the things that try to force us to turn around are weak compared to the tiny grain of self-belief that it takes to get out there and try. We need to forget about what we "), _c('i', [_vm._v("can’t")]), _vm._v(" do and think about what we "), _c('i', [_vm._v("can")]), _vm._v(" do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I was rowing the Atlantic, my crew and I raced the ocean against a boat called "), _c('i', [_vm._v("Dream It. Do It")]), _vm._v(". I wish I’d thought of that name for our boat. No matter where we’re from or what our past has been, we can learn how to dream and act if we overcome whatever version it is of fear that plagues us. I decided to row an ocean because life gets so much better when we stop listening to the reasons why we can’t do something. And that’s why I decided to write this book.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_vm._v("I wanted to share the story of the row, but there is more than one journey in this book. Yes, there is the one with the waves and the broken equipment and the fire and the exhaustion, but there’s ")]), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_vm._v(" another adventure to tell. It’s the one where I learned how to listen to my inner optimist and stop allowing fear to limit my horizon. It’s the voyage back to dreaming and doing. It’s the story of waking up to life.")])]), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("I hope it helps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("Julia")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-689d3c8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 72
// module chunks = 0